var map = {
	"./de.json": [
		"bac1",
		"lang-de-json"
	],
	"./en.json": [
		"e312",
		"lang-en-json"
	],
	"./fr.json": [
		"b16e",
		"lang-fr-json"
	],
	"./it.json": [
		"669f",
		"lang-it-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8825";
module.exports = webpackAsyncContext;